import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const BatchReport = lazy(() => import("./BatchReport"));

const L = DefaultLayout;
const W = withSuspense;

export function getBatchReportRoutes() {
  return [
    { path: "/batch-report/:id", layout: L, element: W(BatchReport) },
  ];
}
